<section class="portal-background">
    <product-header class="portal-custom-header" [directory]="directory"></product-header>
    <product-how-to [directory]="directory"></product-how-to>
    <portal-categories></portal-categories>
    <product-functions [directory]="directory"></product-functions>
    <product-faq [directory]="directory"></product-faq>
    <product-storage [directory]="directory"></product-storage>
</section>